<template>
  <a-layout id="components-layout-side">
    <a-layout-header class="header">
      <div class="layout-header-logo"><Logo /></div>
      <!-- 用户信息 -->
      <div class="layout-header_right-menu"><AvatarMenu /></div>
    </a-layout-header>
    <a-layout>
      <a-layout>
        <!-- 内容 -->
        <a-layout-content class="layout-content">
          <div class="wrap">
            <div class="main">
              <router-view />
            </div>
          </div>
          <Footer />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import Logo from '@/layouts/components/Logo';
import AvatarMenu from '@/layouts/components/AvatarMenu';
import Footer from '@/layouts/components/Footer';
export default {
  components: { Footer, AvatarMenu, Logo },
  data() {
    return {
      collapsed: false
    };
  }
};
</script>

<style lang="less" scoped>
:deep(.header) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 4px !important;
  background-color: #fff;

  .layout-header-logo {
    float: left;
  }
  .layout-header_nav-menu {
    float: left;
  }
  .layout-header_right-menu {
    float: right;
  }
}
.layout-content {
  padding: 16px;
  height: calc(100vh - 50px);
  background: #f5f5f5;
  /* background: rgb(255, 255, 255); */
  overflow-y: auto;
}
.wrap {
  min-height: 100%;
}

.main {
  padding-bottom: 12px;
}
</style>
